import { object, string } from "yup"

export const orderTrackingSchema = object({
  accessionNumber: string().label("Accession Number").required(),
})
